import React, { useEffect, useState } from 'react';
import { Grid, Paper } from '@material-ui/core';
import CustomButton from '../../layout/customButton/CustomButton';
import Modal from '../../layout/modal/Modal';
import ManageLotsTable from './manageLotsTable/ManageLotsTable';
import EditLot from './editLot/EditLot';
import Models from './models/Models';
import Lots from './lots/Lots';
import styles from './SiteplanSection.module.scss';
import { connect } from 'react-redux';
import { checkRolesAccessibilities } from '../../../utils/checkRolesAccessibilities';
import setLotToAvailable from '../../../api/Agreement/setLotToAvailable.api';

const SiteplanSection = (props) => {
	const [manageLotsModal, setManageLotsModal] = useState(false);
	const [editLotInfo, setEditLotInfo] = useState();
	const [lotIdArr, setLotIdArr] = useState([]);
	const [editLotsModal, setEditLotsModal] = useState(false);
	const [stayHighlighted, setStayHighlighted] = useState(true);

	const { userType, rolesAccessibilities } = props;

	const openManageLotsModal = () => {
		setManageLotsModal(true);
	};

	const openEditLotsModal = () => {
		setEditLotsModal(true);
	};

	const closeManageLotsModal = () => {
		setManageLotsModal(false);
	};

	const closeEditLotsModal = () => {
		setEditLotsModal(false);
	};

	return (
		<>
			<Grid item xs={12}>
				<Paper className={styles.siteplan_section}>
					<div className={styles.siteplan_header}>
						<h2 className={styles.siteplan_title}>Site Plan</h2>
						{checkRolesAccessibilities(
							rolesAccessibilities,
							userType,
							'siteplan',
							'siteplan',
							2
						) && (
							<CustomButton
								width='195'
								height='42'
								onClick={openManageLotsModal}
							>
								Manage Lots
							</CustomButton>
						)}
					</div>
					<div className={styles.siteplan_content}>
						<Grid container spacing={2}>
							<Grid item xs={4}>
								<Models
									setStayHighlighted={setStayHighlighted}
								/>
							</Grid>
							<Grid item xs={8}>
								<Lots stayHighlighted={stayHighlighted} />
							</Grid>
						</Grid>
					</div>
				</Paper>
			</Grid>
			<div className={styles.manage_lot_modal}>
				<Modal
					show={manageLotsModal}
					close={closeManageLotsModal}
					title='Manage Lots'
				>
					<ManageLotsTable
						closeManageLotsModal={closeManageLotsModal}
						openEditLotsModal={openEditLotsModal}
						setEditLotInfo={setEditLotInfo}
						setLotIdArr={setLotIdArr}
					/>
				</Modal>
			</div>
			<div className={styles.edit_lot_modal}>
				<Modal show={editLotsModal} close={closeEditLotsModal}>
					<EditLot
						editLotInfo={editLotInfo}
						closeEditLotsModal={closeEditLotsModal}
						lotIdArr={lotIdArr}
					/>
				</Modal>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	userType: state.signIn.userType,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
});

export default connect(mapStateToProps)(SiteplanSection);
